import React, { Component } from 'react';
import './PoolAddCandidates.css';
import { withRouter } from "react-router-dom";
import RecruiterDashboardBar from '../../../components/Recruiter/DashboardBar/DashboardBar';
import AddCandidates from '../../../components/Recruiter/AddCandidates/AddCandidates';
import { JobsData } from '../../../data/jobs';
import { CandidatesData } from '../../../data/candidates';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
/**
* @desc Import candidates to specific  job title 
* @version 0.1.0
* @author Amrutha K K,Jamshith,Praveen George
*/
class PoolAddCandidates extends Component {

  constructor() {
    super();
    this.state = {
    	jobs : JobsData,
      candidates: CandidatesData,
      pool: {
        jobTitle: '',
        clientName: '',
        clientEmail: '',
        clientBHId: '',
        candidates: [{}]
      },
    };
    this.handleComplete = this.handleComplete.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }
/**
 * @desc Cancel/Exit the add candidate page and switch to dashboard
 * @param e
 * @return null
 */
  handleCancel(e) {
    this.props.history.push('/recruiter/dashboard')
  }
/**
 * @desc Save added candidates details and switch to dashboard
 * @param e
 * @return null
 */
  handleComplete(e) {
    this.props.history.push('/recruiter/dashboard')
  }

  render() {
  	const jobs = this.state.jobs;
    const candidates = this.state.candidates;
    return (
    	<div>
        <RecruiterDashboardBar activeLink='manage-jobs' pool={ this.state.pool } />
        <div className="pool-add-candidates">
          <AddCandidates candidates={candidates} />
          <div className="form-buttons">
            <button className="cancel" onClick={ this.handleCancel }>Cancel</button>
            <button className="complete" onClick={ this.handleComplete }>Save</button>
          </div>
        </div>
	    </div>
    )
  }
}

export default withRouter(PoolAddCandidates);


// WEBPACK FOOTER //
// ./src/container/Recruiter/PoolAddCandidates/PoolAddCandidates.js